module.exports = "https://cdn.realtymogul.com/static/media/icon_shield.4119ea6a.svg";